import { render, staticRenderFns } from "./farmingRz.vue?vue&type=template&id=8da0b1b2&scoped=true"
import script from "./farmingRz.vue?vue&type=script&lang=js"
export * from "./farmingRz.vue?vue&type=script&lang=js"
import style0 from "./farmingRz.vue?vue&type=style&index=0&id=8da0b1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da0b1b2",
  null
  
)

export default component.exports